import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { LegacyAutocompleteOptionPropTypes } from './legacy-autocomplete-option.js';

const LegacyAutocompleteOptionGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    bem,
    groupName,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("ul", {
    role: "group",
    ref: ref,
    className: bem.e('list'),
    "aria-labelledby": groupName === null || groupName === void 0 ? void 0 : groupName.props.id
  }, groupName, children);
});
const LegacyAutocompleteGroupName = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    bem,
    id,
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("li", {
    role: "presentation",
    id: id,
    ref: ref,
    className: bem.e('group-name')
  }, children);
});
const LegacyAutocompleteGroupPropTypes = PropTypes.shape({
  group: PropTypes.node.isRequired,
  key: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(LegacyAutocompleteOptionPropTypes).isRequired
});

export { LegacyAutocompleteGroupName, LegacyAutocompleteGroupPropTypes, LegacyAutocompleteOptionGroup };
